import { Component, OnInit } from '@angular/core';
import { UserAccount } from 'app/objects';
import { ApiService } from 'app/services/api.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-edit-user',
  templateUrl: './edit-user.component.html',
  styleUrls: ['./edit-user.component.css']
})
export class EditUserComponent implements OnInit {

  public user: UserAccount;
  public loginError: string;
  public isNewUser: boolean;

  constructor(private apiSvc: ApiService, private dialog: MatDialogRef<EditUserComponent>) { }

  ngOnInit() {
  }

  public setUser(user: UserAccount) {
    this.user = Object.assign({}, user);
    console.log("New user: ", user, this.user);

    if (this.user.Id == null) {
      this.isNewUser = true;
    } else {
      this.isNewUser = false;
    }
  }

  public save() {

    var isNewUser = (this.user.Id == null);

    var url = "api/UserAccount/Save";
    if (isNewUser) {
      url = "api/UserAccount/CreateUser";
    }
 
    this.apiSvc.post(url, this.user).subscribe((user) => {
      console.log(user);
      this.dialog.close(user);
    }, (err) => {
      console.log("ERROR", err);

      var errMsg = "";
      if (err.Message != null) {
        errMsg = err.Message;
      }

      alert("There was an error: " + errMsg);
    });
  }

  public resetPassword() {

    var payload = {
      UserId: this.user.Id
    };

    var url = "api/UserAccount/InitiatePasswordReset";
    this.apiSvc.post(url, payload).subscribe((user) => {
      console.log(user);
      //this.dialog.close(user);
      alert("A reset password request has been emailed to the user");
    }, (err) => {
      console.log("ERROR", err);
      alert("There was an error: " + err);
    });

  }

}


